
import TagManager from "react-gtm-module";
if (process.env.REACT_APP_GTM_CODE) {
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_CODE
  })
}
